module.exports = __webpack_public_path__ + "static/media/irregular-income-gambling.8637bb8f.svg";